import { ca } from '@cian/analytics';

export const trackScrollToEstimationBlock = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'New_ad',
    action: 'Scroll',
    label: 'EstateCalculatorBlock',
  });
};
